import {
  apiRequest,
  cpnsCreate,
  cpnsPeriodDetail,
  cpnsGetProjection,
  masterRegion,
  masterEducation,
  masterRank,
  masterPosition,
  masterWorkUnit,
  masterGajiwebAgama,
  masterGajiwebSatker,
  masterBank,
  masterGajiwebBankSpan,
  masterEmployeeCategories,
  masterEmployee,
  cpnsList,
  cpnsDetail,
  cpnsDelete,
  cpnsCreateDecreeCollective,
  cpnsDetailDecreeCollective,
  cpnsDownloadDraftSK,
  cpnsDownloadSKCollective,
  cpnsImportExcel,
} from "../../../../../services/adapters/kepegawaian/cpnsService";

class CreateRepository {
  fetchCreate = async (query) => {
    return await apiRequest(
      "post",
      cpnsCreate,
      {
        body: query,
      },
      true
    );
  };

  fetchDetailPeriod = async (query) => {
    return await apiRequest(
      "get",
      cpnsPeriodDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchGetProjection = async (query) => {
    return await apiRequest(
      "get",
      cpnsGetProjection,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCountry = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionProvince = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchRegionCity = async (query) => {
    return await apiRequest(
      "get",
      masterRegion,
      {
        params: query,
      },
      true
    );
  };

  fetchEducation = async (query) => {
    return await apiRequest(
      "get",
      masterEducation,
      {
        params: query,
      },
      true
    );
  };

  fetchRank = async (query) => {
    return await apiRequest(
      "get",
      masterRank,
      {
        params: query,
      },
      true
    );
  };

  fetchPosition = async (query) => {
    return await apiRequest(
      "get",
      masterPosition,
      {
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  fetchAgamaGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebAgama,
      {
        params: query,
      },
      true
    );
  };

  fetchSatkerGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebSatker,
      {
        params: query,
      },
      true
    );
  };

  fetchBank = async (query) => {
    return await apiRequest(
      "get",
      masterBank,
      {
        params: query,
      },
      true
    );
  };

  fetchBankSpanGajiWeb = async (query) => {
    return await apiRequest(
      "get",
      masterGajiwebBankSpan,
      {
        params: query,
      },
      true
    );
  };

  fetchEmpCategories = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeCategories,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployee = async (query) => {
    return await apiRequest(
      "get",
      masterEmployee,
      {
        params: query,
      },
      true
    );
  };

  fetchListCandidate = async (query) => {
    return await apiRequest(
      "get",
      cpnsList,
      {
        params: query,
      },
      true
    );
  };

  fetchDetailCandidate = async (query) => {
    return await apiRequest(
      "get",
      cpnsDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchDeleteCandidate = async (query) => {
    return await apiRequest(
      "post",
      cpnsDelete,
      {
        body: query,
      },
      true
    );
  };

  fetchCreateDecreeCollective = async (query) => {
    return await apiRequest(
      "post",
      cpnsCreateDecreeCollective,
      {
        body: query,
      },
      true
    );
  };

  fetchDetailDecreeCollective = async (query) => {
    return await apiRequest(
      "get",
      cpnsDetailDecreeCollective,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadDraftSK = async (query) => {
    return await apiRequest(
      "get",
      cpnsDownloadDraftSK,
      {
        params: query,
      },
      true
    );
  };

  fetchDownloadSKCollective = async (query) => {
    return await apiRequest(
      "get",
      cpnsDownloadSKCollective,
      {
        params: query,
      },
      true
    );
  };

  fetchImportExcel = async (query) => {
    return await apiRequest(
      "post",
      cpnsImportExcel,
      {
        body: query,
      },
      true
    );
  };
}

export default CreateRepository;
